export const COGNITO_AUTH = {
  ENABLED: false,
};
